import React from 'react';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

interface SidebarToggleProps {
  collapsed: boolean;
  onToggle: () => void;
  position?: 'left' | 'right';
}

export const SidebarToggle: React.FC<SidebarToggleProps> = ({
  collapsed,
  onToggle,
  position = 'left'
}) => {
  const icon = position === 'left' 
    ? (collapsed ? <RightOutlined /> : <LeftOutlined />)
    : (collapsed ? <LeftOutlined /> : <RightOutlined />);

  return (
    <Button
      type="text"
      icon={icon}
      onClick={onToggle}
      style={{
        position: 'absolute',
        top: '16px', // Align with header padding
        [position]: collapsed ? '8px' : '-8px',
        zIndex: 9999,
        backgroundColor: '#1e3a8a',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: 'white',
        width: '24px',
        height: '24px',
        minWidth: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#2563eb';
        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#1e3a8a';
        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
      }}
    />
  );
};
